import { combineReducers } from 'redux'
import excelReportGenReducer from "./reducers/excelReportGenReducer";
import pdfReportGenReducer from "./reducers/pdfReportGenReducer";
import csvReportGenReducer from "./reducers/csvReportGenReducer";


const reportRootReducer = combineReducers({
    excelReports: excelReportGenReducer,
    pdfReports: pdfReportGenReducer,
    csvReports: csvReportGenReducer,
});

export default reportRootReducer;
